import { useState, useEffect } from "react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import axios from "axios";
import { Quote } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = '/api';

export default function AtaturkQuote() {
  const [quote, setQuote] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchQuote = async () => {
      try {
        const response = await axios.get(`${API}/ataturk/quote-of-the-day`);
        setQuote(response.data);
      } catch (error) {
        console.error("Atatürk sözü yüklenemedi:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchQuote();
  }, []);

  if (loading) {
    return (
      <Card className="p-4 bg-gradient-to-br from-orange-500/10 to-orange-600/5 border-orange-500/20 animate-pulse">
        <div className="h-24"></div>
      </Card>
    );
  }

  if (!quote) return null;

  return (
    <Card className="p-4 bg-gradient-to-br from-orange-500/10 to-orange-600/5 border-orange-500/20 hover:border-orange-500/40 transition-all duration-300">
      <div className="flex items-center gap-3 mb-2">
        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center flex-shrink-0">
          <Quote className="w-5 h-5 text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-bold text-white truncate">Günün Atatürk Sözü</h3>
          {quote.category && (
            <Badge className="bg-orange-500/80 text-white text-xs mt-1">
              {quote.category === 'eğitim' && '📚 Eğitim'}
              {quote.category === 'cumhuriyet' && '🏛️ Cumhuriyet'}
              {quote.category === 'millet' && '🇹🇷 Millet'}
              {quote.category === 'kadın' && '👩 Kadın'}
              {quote.category === 'demokrasi' && '⚖️ Demokrasi'}
              {quote.category === 'barış' && '🕊️ Barış'}
              {quote.category === 'kültür' && '🎭 Kültür'}
              {quote.category === 'teknoloji' && '🚀 Teknoloji'}
              {quote.category === 'özgürlük' && '🗽 Özgürlük'}
            </Badge>
          )}
        </div>
      </div>
      
      <blockquote className="border-l-2 border-orange-400 pl-3">
        <p className="text-white/90 text-sm italic line-clamp-3 mb-2">
          "{quote.quote}"
        </p>
        <p className="text-orange-200/70 text-xs">
          — M. Kemal Atatürk {quote.year && `(${quote.year})`}
        </p>
      </blockquote>
    </Card>
  );
}
